export default "__VITE_ASSET__Bk6ebffn__"